<template>
  <div class="home-container">
    <p class="subtitle-first">{{$t('home.subtitleFirst')}}</p>
    <h1 class="title">Your Personal <span class="highlight">Tutor</span></h1>
    <p class="subtitle">{{$t('home.subtitle')}}</p>

    <div class="search-section">
      <el-input
        v-model="searchTopic"
        type="textarea"
        rows={1}
        resize="none"
        :placeholder="$t('home.searchPlaceholder')"
        class="topic-input"
      />
      <el-select v-model="educationLevel" class="level-select">
        <el-option :label="$t('home.levelElementary')" value="elementary-school" />
        <el-option :label="$t('home.levelMiddle')" value="middle-school" />
        <el-option :label="$t('home.levelHigh')" value="high-school" />
      </el-select>
      <el-button type="primary" class="search-btn" @click="handleSearch">
        <i class="el-icon-top-right"></i>
      </el-button>
    </div>

    <div class="topics">
      <el-tag class="topic-tag" @click="toMytec()">
        <img src="@/assets/MYTEC.png" alt="MYTEC" />
        MYTUTOR
      </el-tag>
      <el-tag class="topic-tag" @click="selectTopic('UEC')">
        <img src="@/assets/UEC.png" alt="UEC" style="width: 48px"/>
        UEC
      </el-tag>
    </div>

    <div class="footer">
      <a href="https://mytec-edu.com/" target="_blank">{{$t('home.footerLink')}}</a>
    </div>
  </div>
</template>

<script>
/**
 * @description 个性化导师主页组件
 */
export default {
  name: 'Home',
  data () {
    return {
      searchTopic: '',
      educationLevel: 'middle-school'
    }
  },
  methods: {
    /**
     * @description 处理搜索按钮点击事件
     */
    handleSearch () {
      if (!this.searchTopic.trim()) {
        this.$message.warning(this.$t('home.needTopic'))
        return
      }

      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (!userInfo) {
        // 未登录，跳转到登录页面，并携带重定向信息
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/chat',
            topic: this.searchTopic
          }
        })
      } else {
        // 已登录，直接跳转到聊天页面
        this.$router.push({
          path: '/chat',
          query: { topic: this.searchTopic }
        })
      }
    },
    /**
     * @description 选择预设主题
     * @param {string} topic - 主题名称
     */
    selectTopic (topic) {
      this.searchTopic = topic
    },
    toMytec () {
      window.open('https://mytec-edu.com/', '_blank')
    }
  }
}
</script>

<style scoped>
.home-container {
  height: calc(100vh - 84px);
  width: 100%;
  max-width: 650px;
  margin: auto;
  text-align: center;
  background: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-family: 'Orbitron', 'Rajdhani', sans-serif;
  font-style: italic;
  padding: 0 20px;
}

.title {
  font-size: 24px;
  margin-bottom: 15px;
  position: relative;
  z-index: 1;
}

.highlight {
  color: #409EFF;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
  font-family: 'Orbitron', 'Rajdhani', sans-serif;
  font-style: italic;
  font-size: 14px;
}

.subtitle-first {
  color: #409EFF;
  align-items: center;
  font-family: 'Orbitron', 'Rajdhani', sans-serif;
  font-style: italic;
  position: relative;
  top: -10%;
  margin-bottom: -20px;
  font-size: 14px;
}

.search-section {
  display: flex;
  margin-bottom: 20px;
  align-items: stretch;
  font-family: 'Orbitron', 'Rajdhani', sans-serif;
  font-style: italic;
  flex-direction: column;
  gap: 10px;
}

.topic-input {
  flex: 1;
}

.topic-input >>> .el-textarea__inner {
  height: 50px !important;
  border-radius: 4px;
  resize: none;
  padding: 12px 8px;
  font-size: 14px;
}

.topic-input >>> .el-textarea__inner::placeholder {
  font-size: 14px;
}

.level-select {
  width: 100%;
  font-family: 'Orbitron', 'Rajdhani', sans-serif;
  font-style: italic;
}

.level-select >>> .el-input__inner {
  height: 50px;
  border-radius: 4px;
}

.search-btn {
  width: 100%;
  padding: 0 22px;
  height: 50px;
  background: linear-gradient(154deg, #2a8ef9 23.37%, #175cb6 91.91%);
}

.topics {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 30px;
  font-family: 'Orbitron', 'Rajdhani', sans-serif;
  font-style: italic;
}

.topic-tag {
  cursor: pointer;
  padding: 6px 12px;
  font-size: 13px;
  display: flex;
  align-items: center;
  height: 36px;
}

.topic-tag img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.topic-tag:hover {
  opacity: 0.8;
}

.footer {
  color: #666;
  font-size: 13px;
}

.footer a {
  color: #409EFF;
  text-decoration: none;
  font-family: 'Orbitron', 'Rajdhani', sans-serif;
  font-style: italic;
}

.footer a:hover {
  text-decoration: underline;
}

/* 移动端适配 */
@media screen and (min-width: 768px) {
  .home-container {
    width: 40%;
    padding: 0;
  }

  .title {
    font-size: 30px;
    margin-bottom: 20px;
  }

  .subtitle {
    margin-bottom: 40px;
    font-size: 16px;
  }

  .subtitle-first {
    margin-bottom: -30px;
    font-size: 16px;
  }

  .search-section {
    flex-direction: row;
    margin-bottom: 30px;
    gap: 0;
  }

  .topic-input >>> .el-textarea__inner {
    height: 60px !important;
    border-radius: 4px 0 0 4px;
    padding: 17px 8px;
    font-size: 16px;
  }

  .topic-input >>> .el-textarea__inner::placeholder {
    font-size: 16px;
  }

  .level-select {
    width: 200px;
  }

  .level-select >>> .el-input__inner {
    height: 60px;
    border-radius: 0 4px 4px 0;
    border-left: none;
  }

  .search-btn {
    width: auto;
    margin-left: 20px;
    height: 60px;
  }

  .topics {
    gap: 15px;
    margin-bottom: 40px;
  }

  .topic-tag {
    padding: 8px 16px;
    font-size: 14px;
    height: 40px;
  }

  .topic-tag img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  .footer {
    font-size: 14px;
  }
}
</style>
